const doc = [({"ja":({"adminButtonUser":({"backToUserIndex":"会員一覧へ戻る"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;